import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { login } from '../../reducers/authReducer'
import logo from '../../assets/logo.jpg'
import { Form, Input, Button, Checkbox, Divider, Card, Typography, Space } from 'antd'
import { MailOutlined, LockOutlined, GoogleOutlined, UserOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

// Enhanced styles using Ant Design's design tokens
const styles = {
  pageContainer: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px'
  },
  loginCard: {
    width: '100%',
    maxWidth: '600px',
    borderRadius: '12px',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    border: 'none'
  },
  cardBody: {
    padding: '40px 32px'
  },
  logoContainer: {
    textAlign: 'center',
    marginBottom: '32px'
  },
  logo: {
    height: '65px',
    width: '150px',
    marginBottom: '16px'
  },
  welcomeTitle: {
    color: '#1f2937',
    fontSize: '28px',
    fontWeight: '600',
    margin: '0 0 8px 0'
  },
  subtitle: {
    color: '#6b7280',
    fontSize: '16px',
    margin: '0 0 32px 0'
  },
  formTitle: {
    color: '#1f2937',
    fontSize: '20px',
    fontWeight: '500',
    marginBottom: '24px',
    textAlign: 'center'
  },
  inputStyle: {
    height: '45px',
    borderRadius: '8px'
  },
  loginButton: {
    height: '45px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '500'
  },
  googleButton: {
    height: '45px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '500',
    borderColor: '#d1d5db'
  },
  rememberForgot: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px'
  },
  forgotLink: {
    color: '#4f46e5',
    textDecoration: 'none'
  },
  dividerText: {
    color: '#6b7280',
    fontSize: '14px'
  },
  signupPrompt: {
    textAlign: 'center',
    marginTop: '24px',
    color: '#6b7280'
  },
  signupLink: {
    color: '#4f46e5',
    fontWeight: '500'
  }
}

const Login = () => {
  const dispatch = useDispatch()

  const onFinish = (values) => {
    if (values.remember) {
      window.localStorage.setItem(
        'HogarTMS-credentials',
        JSON.stringify({ remember: values.remember, username: values.username })
      )
    } else {
      window.localStorage.setItem(
        'HogarTMS-credentials',
        JSON.stringify({ remember: false })
      )
    }
    dispatch(login({...values, "appName": "TMS"}))
  }

  const getInitialValues = () => {
    try {
      return JSON.parse(window.localStorage.getItem('HogarTMS-credentials')) || {}
    } catch {
      return {}
    }
  }

  return (
    <div style={styles.pageContainer}>
      <Card style={styles.loginCard}>
        <div style={styles.cardBody}>
          {/* Logo and Welcome Section */}
          <div style={styles.logoContainer}>
            <img src={logo} alt="TMS Logo" style={styles.logo} />
            <Title level={2} style={styles.welcomeTitle}>
              Welcome Back
            </Title>
            <Text style={styles.subtitle}>
              Sign in to your TMS account
            </Text>
          </div>

          <Form
            name="login"
            onFinish={onFinish}
            initialValues={getInitialValues()}
            scrollToFirstError
            layout="vertical"
            size="large"
          >
            {/* Email Input */}
            <Form.Item
              label="Email Address"
              name="username"
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email address'
                },
                {
                  required: true,
                  message: 'Email address is required'
                }
              ]}
            >
              <Input 
                prefix={<MailOutlined style={{ color: '#9ca3af' }} />} 
                placeholder="Enter your email"
                style={styles.inputStyle}
              />
            </Form.Item>

            {/* Password Input */}
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Password is required'
                },
                {
                  min: 6,
                  message: 'Password must be at least 6 characters'
                }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#9ca3af' }} />}
                placeholder="Enter your password"
                style={styles.inputStyle}
              />
            </Form.Item>

            {/* Remember Me & Forgot Password */}
            <div style={styles.rememberForgot}>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
              <Link to="/forgot-password" style={styles.forgotLink}>
                Forgot password?
              </Link>
            </div>

            {/* Login Button */}
            <Form.Item>
              <Button 
                block 
                type="primary" 
                htmlType="submit"
                style={styles.loginButton}
                // loading={loading}
              >
                Sign In
              </Button>
            </Form.Item>

            {/* Divider */}
            {/* <Divider style={styles.dividerText}>
              <span style={styles.dividerText}>or continue with</span>
            </Divider> */}

            {/* Google Sign In */}
            {/* <Form.Item>
              <Button 
                block 
                icon={<GoogleOutlined />}
                style={styles.googleButton}
              >
                Sign in with Google
              </Button>
            </Form.Item> */}

            {/* Sign Up Prompt */}
            {/* <div style={styles.signupPrompt}>
              <Text>Don't have an account? </Text>
              <Link to="/register" style={styles.signupLink}>
                Create one now
              </Link>
            </div> */}
          </Form>
        </div>
      </Card>
    </div>
  )
}

export default Login